import { useCallback, ChangeEvent } from 'react';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { languages, namespaces } from "../i18n.costants";

export function LanguageSelection() {
  const { i18n } = useTranslation(namespaces.common);
  const currentLanguage = i18n.language;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      console.log(event.target.value, currentLanguage)

      void i18n.changeLanguage(event.target.value);
    },
    [i18n, currentLanguage]
  );

  return (
    <Select value={currentLanguage} onChange={handleChange}>
      {Object.keys(languages).map((lang) => (
        <Option key={lang} value={lang}>
          {lang.toUpperCase()}
        </Option>
      ))}
    </Select>
  )
}

const Select = styled.select`
  border: none;
  background: var(--color-gray-light);
  font-weight: 500;
  cursor: pointer;
  margin-right: 1em;
    width: 3em;

  &:focus {
    outline: none;
    border: 2px solid var(--color-text);
      border-radius: 1em;
  }
`;

const Option = styled.option`
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: hsl(227deg 40% 20%);
  }
`;